<template>
  <section>
    <v-container fluid>

      <ControlHeader :pageData="pageData" :form="form" :save="save" :valid="!disabled" :deleteMethod="deleteMethod" />

      <!-- Form -->
      <v-form ref="form" v-model="valid" class="pa-3" :key="componentId">
        <v-card class="backgroundW shadow pa-5 pt-7">
          <v-row>
            <v-col md="6">
              <v-col cols="12">
                <FileInput type="file" :solo="true" :outlined="false" label="image" :value="form.image" placeholder="select image" :hideImage="false"
                  prependIcon="mdi-camera" @input="form.image = $event" :required="true" :multi="false" :base64="false"
                  :cols="[12, 12, 12]" class="mt-2" />
              </v-col>

              <GenericInput type="select" :lookups="categories" :value="form.category_id"
                @input="form.category_id = $event" label="category" :multi="false" :required="true"
                selected_label="name" selected_prop="id" :isLoading="pageData.isLoading" :cols="[12, 12, 12]">
                <template v-slot:append>
                  <v-btn icon class="mt-n1 mx-n2" color="success" @click="quickAddDialog = true">
                    <v-icon>mdi-plus-box</v-icon>
                  </v-btn>
                </template>

                <template v-slot:selection="{ item }">
                  {{ item.name }}
                </template>

                <template v-slot:item="{ item }">
                  <div class="cat-item">
                    <span> {{ item.name }}</span>
                    <span @click.stop>
                      <v-icon @click="selecteCategoryEdit(item)" class="mx-2" color="gray6"
                        size="18">mdi-pencil</v-icon>
                      <v-icon @click="categoryDeleteMethod(item)" color="red" size="18">mdi-delete</v-icon>
                    </span>
                  </div>
                </template>
              </GenericInput>

              <v-col cols="12" class="font-weight-bold" dir="ltr">
                <v-divider /><v-divider class="mb-4" />
                {{ $t('SEO Meta Tags') }} :
              </v-col>

              <GenericInput type="text" dir="rtl" :value="form.seo_title_ar" @input="form.seo_title_ar = $event"
                label="عنوان عربي" :required="false" :isLoading="pageData.editIsLoading" :cols="[12, 12, 12]" />

              <GenericInput type="text" dir="ltr" :value="form.seo_title_en" @input="form.seo_title_en = $event"
                label="Title in English" :required="false" :isLoading="pageData.editIsLoading" :cols="[12, 12, 12]" />

              <GenericInput type="text" dir="rtl" :value="form.seo_alt_en" @input="form.seo_alt_en = $event"
                label="ALT الصورة" :required="false" :isLoading="pageData.editIsLoading" :cols="[12, 12, 12]" />

              <GenericInput type="text" dir="ltr" :value="form.seo_alt_ar" @input="form.seo_alt_ar = $event"
                label="Image Alt in English" :required="false" :isLoading="pageData.editIsLoading"
                :cols="[12, 12, 12]" />



              <GenericInput type="combobox" dir="rtl" :multi="true" :lookups="form.seo_keywords_ar"
                :value="form.seo_keywords_ar" @input="form.seo_keywords_ar = $event" label="keywords عربي"
                :required="false" :isLoading="pageData.editIsLoading" :cols="[12, 12, 12]" />

              <GenericInput type="combobox" dir="rtl" :multi="true" :lookups="form.seo_keywords_en"
                :value="form.seo_keywords_en" @input="form.seo_keywords_en = $event" label="keywords In English"
                :required="false" :isLoading="pageData.editIsLoading" :cols="[12, 12, 12]" />

              <GenericInput type="textarea" dir="rtl" :value="form.seo_desc_ar" @input="form.seo_desc_ar = $event"
                label="الوصف في SEO" :required="false" :isLoading="pageData.editIsLoading" :cols="[12, 12, 12]" />

              <GenericInput type="textarea" dir="ltr" :value="form.seo_desc_en" @input="form.seo_desc_en = $event"
                label="Description in SEO" :required="false" :isLoading="pageData.editIsLoading" :cols="[12, 12, 12]" />


            </v-col>

            <v-col md="6">
              <GenericInput type="text" :value="form.title_ar" @input="form.title_ar = $event" label="عنوان عربى"
                :required="true" :isLoading="false" :cols="[12, 12, 12]" class="mt-1" />

              <GenericInput type="text" dir="ltr" :value="form.title_en" @input="form.title_en = $event"
                label="English title" :required="true" :isLoading="false" :cols="[12, 12, 12]" class="mt-1" />

              <GenericInput type="textarea" :value="form.short_description_ar"
                @input="form.short_description_ar = $event" label="وصف مختصر عربى" :required="true" :isLoading="false"
                :cols="[12, 12, 12]" class="mt-1" />

              <GenericInput type="textarea" dir="ltr" :value="form.short_description_en"
                @input="form.short_description_en = $event" label="short description english" :required="true"
                :isLoading="false" :cols="[12, 12, 12]" class="mt-1" />

              <GenericInput type="texteditor" :value="form.description_ar" @input="form.description_ar = $event"
                label="الوصف عربى" :required="true" :isLoading="false" :cols="[12, 12, 12]" class="mt-2"
                :inputDesign="true" />

              <GenericInput type="texteditor" dir="ltr" :value="form.description_en"
                @input="form.description_en = $event" label="Details english" :required="true" :isLoading="false"
                :cols="[12, 12, 12]" class="mt-2" :inputDesign="true" />

            </v-col>



          </v-row>
        </v-card>

      </v-form>
      <!-- End of Form -->
    </v-container>
    <CustomModal :buttonOneLoading="saveDataLoading" :dialog="deleteCatDialog" :opacity="0.6"
      :buttonOneMethod="() => selecteCategoryDelete()"
      :buttonTwoMethod="() => (deleteCatDialog = false, catSelectedRow = {})" :dialogContent="{
        title: 'are you sure you want to delete',
        selectedTitle: catSelectedRow.name,
        buttonOneTitle: 'yes',
        buttonOneColor: 'primary',
        buttonTwoTitle: 'no',
        buttonTwoColor: 'error',
      }" />

    <QuickAddDialog :dialog="quickAddDialog" :closeDialog="() => (quickAddDialog = false, catSelectedRow = {})"
      :setQuickAdd="setNewAdd" :catSelectedRow="catSelectedRow" />
  </section>
</template>


<script>
import GenericInput from '@/components/ui/GenericInput.vue';
import ControlHeader from "@/components/ui/ControlHeader.vue";
import QuickAddDialog from './QuickAddDialog.vue';
import CustomModal from "@/components/modals/CustomModal.vue";
import FileInput from '@/components/ui/FileInput.vue';


export default {
  name: "BlogControl",

  data: () => ({
    pageData: {
      screen_code: "02-014",
      url: null,
      controlRoute: "/website/blog-control/",
      entityName: null,
      main: null,
      category: null,
      isLoading: false,
      isEdit: false,
      editIsLoading: false,
    },
    valid: false,
    form: {
      title_ar: null,
      title_en: null,
      category_id: null,
      description_ar: null,
      description_en: null,
      short_description_ar: null,
      short_description_en: null,
      image: null,
      seo_alt_ar: null,
      seo_alt_en: null,
      seo_desc_ar: null,
      seo_desc_en: null,
      seo_title_ar: null,
      seo_title_en: null,
      seo_keywords_ar: null,
      seo_keywords_en: null,
    },
    quickAddDialog: false,
    deleteCatDialog: false,
    saveDataLoading: false,
    categories: [],
    catSelectedRow: {},
    componentId: 0,


  }),

  computed: {
    disabled() {
      return (
        Object.keys(this.form).some(key => !this.form[key])
      );
    }
  },
  mounted() {
    this.pageMainData()
    this.getData()
  },
  watch: {

  },
  methods: {

    pageMainData() {
      this.pageData.main = this.$global.FilterPermissions(this.pageData.screen_code).main_title;
      this.pageData.category = this.$global.FilterPermissions(this.pageData.screen_code).cat_title;
      this.pageData.url = this.$global.FilterPermissions(this.pageData.screen_code).url;
      this.pageData.entityName = this.$route.params.id ? this.$i18n.t("edit") + " " + this.$global.FilterPermissions(this.pageData.screen_code).sub_title : this.$i18n.t("add") + " " + this.$global.FilterPermissions(this.pageData.screen_code).sub_title;
    },
    getData() {
      if (this.$route.params.id) {
        if (this.$global.CheckAction(this.pageData.screen_code, 3)) {
          this.pageData.isEdit = true;
          this.pageData.editIsLoading = true;
          this.pageData.isLoading = true;
          this.$api.GET_METHOD(`blogs/${this.$route.params.id}`).then((response) => {
            this.pageData.editIsLoading = false;
            this.pageData.isLoading = false;
            if (response.check) {
              console.log("response", response);
              this.categories = response.data.categories
              Object.keys(this.form).forEach(key => {
                this.form[key] = response.data.data[key]
              });
              this.form.seo_keywords_ar = this.form.seo_keywords_ar?.split(',').map(i => i);
              this.form.seo_keywords_en = this.form.seo_keywords_en?.split(',').map(i => i);
              this.$refs.form.validate();
            }
          })
        } else {
          this.$router.push('/')
        }
      } else {
        if (this.$global.CheckAction(this.pageData.screen_code, 2)) {

          this.pageData.isLoading = true;
          this.$api.GET_METHOD(`blogs/create`).then((response) => {
            this.pageData.isLoading = false;
            if (response.check) {
              this.categories = response.data.categories
            }
          })
        } else {
          this.$router.push('/')
        }

      }

    },
    save() {
      if (this.$refs.form.validate()) {
        this.pageData.isLoading = true;

        if (this.pageData.isEdit == true) {
          let requestBody = { ...this.form, _method: 'PUT' };
          requestBody.seo_keywords_ar = this.form.seo_keywords_ar?.toString();
          requestBody.seo_keywords_en = this.form.seo_keywords_en?.toString();
          // requestBody.image = this.form?.image?.substring(0, 7) == '/upload' ? null : this.form?.image;
          this.$api.POST_METHOD(`blogs/${this.$route.params.id}`, this.$global.FormData(requestBody)).then((response) => {
            this.pageData.isLoading = false;
            if (response.check == true) {
              this.$router.push(this.pageData.url)
            }
          })
        }
        else {
          let requestBody = { ...this.form, };
          requestBody.seo_keywords_ar = this.form.seo_keywords_ar?.toString();
          requestBody.seo_keywords_en = this.form.seo_keywords_en?.toString();
          this.$api.POST_METHOD(`blogs`, this.$global.FormData(requestBody)).then((response) => {
            this.pageData.isLoading = false;
            if (response.check == true) {
              this.$router.push(this.pageData.url)
            }
          })
        }
      }
    },
    deleteMethod(status) {
      if (status == true) {
        this.pageData.isLoading = true
        this.$api.POST_METHOD_MULTIPART(`blogs/${this.$route.params.id}`, { _method: 'delete' }).then(() => {
          this.$router.push(this.pageData.url)
          this.pageData.isLoading = false
        })
      }
    },
    setNewAdd(newItem) {
      const index = this.categories.findIndex(item => item.id === newItem.id);
      if (index != -1) {
        this.categories[index] = newItem;
      } else {
        this.categories.push({ ...newItem });
      }
      this.form.category_id = newItem.id
      this.componentId += 1
    },
    selecteCategoryEdit(item) {
      this.catSelectedRow = item;
      this.quickAddDialog = true
      console.log(item);
    },
    categoryDeleteMethod(item) {
      this.catSelectedRow = item;
      this.deleteCatDialog = true;
    },
    selecteCategoryDelete() {
      this.saveDataLoading = true;
      this.$api.POST_METHOD(`categories_toggle/${this.catSelectedRow.id}`, null).then((response) => {
        this.saveDataLoading = false;
        this.deleteCatDialog = false;
        if (response) {
          this.categories = this.categories.filter(category => category.id != this.catSelectedRow.id);
          this.form.category_id = null;
        }
      })
    },

  },

  components: {
    ControlHeader,
    GenericInput,
    QuickAddDialog,
    CustomModal,
    FileInput
  },

};
</script>

<style scoped lang="scss">
#userSelections {
  .v-chip.v-size--small {
    display: none !important;
  }
}

.cat-item {
  width: 100%;
  display: flex;
  justify-content: space-between;
}
</style>